import { createFileRoute } from "@tanstack/react-router"
import { SocialMatchRequestPage } from "@/pages/social-match"

export const Route = createFileRoute("/_authenticated/social-match/request")({
	component: SocialMatchRequestPage,
})
